import React, { FunctionComponent } from 'react'
import AgTechHeaderDetail, { AgTechHeaderDetailProps } from '../../Headers/AgTechHeaderDetail';
import AgTechIconBadge from '../../Icons/AgTechIconBadge';

export enum AgTechToastType
{
    Info,
    Warning,
    Error,
    Success
}

export type AgTechToastProps = {
    type: AgTechToastType
}

let AgTechToast = (props: React.PropsWithChildren<AgTechToastProps>) => {
    let toastClass = props.type === AgTechToastType.Info ? 'toast-info'
                   : props.type === AgTechToastType.Warning ? 'toast-warning'
                   : props.type === AgTechToastType.Error ? 'toast-error'
                   : props.type === AgTechToastType.Success ? 'toast-success'
                   : 'toast-info';
                   
    return (
        <div className={`column-based items-center rounded bg-white wide overflow-auto flex ${toastClass}`}>
            {props.children}
        </div>
    )
};

export const AgTechStandardToast = (props: {
    type: AgTechToastType,
    toast: {
        header: string,
        detail?: string,
        icon?: string,
        content?: () => JSX.Element
    }
}) => {
    const toast = props.toast;
    const toastType = props.type ?? AgTechToastType.Info;
    const toastStyles = AgTechToastStyles[toastType];
    
    return (
        <div className={`column-based items-center rounded bg-white wide min-h-[76px] max-h-[320px] overflow-hidden flex`}>
            <AgTechHeaderDetail
                header={toast.header}
                detail={toast.detail}
                settings={{
                    classes: `tall column-based-vertically-centered rounded py-4 px-4 pr-6 border border-l-[5px] ${toastStyles.border}`,
                    header: {
                        classes: '!text-plus'
                    },
                    detail: {
                        classes: '!text-base mt-[4px] overflow-auto'
                    },
                    badge: {
                        badgeSize: 36,
                        icon: toastStyles.icon,
                        classes: `mr-5 ${toastStyles.classes}`
                    },
                    content: {
                        body: toast.content ? toast.content : undefined
                    }
                }}
            />
        </div>
    )
}

const AgTechToastStyles = {
    [AgTechToastType.Info]: {
        classes: '!bg-blue-400 text-white',
        border: 'border-blue-600',
        icon: 'fas fa-info'
    },
    [AgTechToastType.Success]: {
        classes: '!bg-green-400 text-white',
        border: 'border-green-600',
        icon: 'fas fa-check'
    },
    [AgTechToastType.Warning]: {
        classes: '!bg-yellow-400 text-white',
        border: 'border-yellow-600',
        icon: 'fas fa-exclamation'
    },
    [AgTechToastType.Error]: {
        classes: '!bg-red-700 text-white rounded-full centered',
        border: 'border-red-700',
        icon: 'fas fa-exclamation'
    }
}

export default AgTechToast;